import { useMutation } from "@apollo/client";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import PropTypes from "prop-types";

import SubmitButton from "../../../../components/common/SubmitButton";
import CustomFormGroup from "../../../../components/form/CustomFormGroup";
import {
  CREATE_STAFF,
  UPDATE_STAFF,
} from "../../../../graphql/mutations/management";
import { GET_STAFF_LIST } from "../../../../graphql/queries/management";
import {
  clearFormStaff,
  onChangeStaff,
} from "../../../management/redux/managementSlice";

const StaffForm = ({ handleClose }) => {
  const dispatch = useDispatch();
  const management = useSelector((state) => state.management);
  const { updateForm, createForm, isEdit } = management;

  const [updateStaff, { loading }] = useMutation(UPDATE_STAFF, {
    variables: {
      id: updateForm.id,
      input: {
        fullname: updateForm.fullname,
      },
    },
    refetchQueries: [{ query: GET_STAFF_LIST }],
    onCompleted: (data) => {
      if (data) {
        handleClose();
        toast.success(`ປັບປຸງຂໍ້ມູນສຳເລັດແລ້ວ`, {
          position: "top-center",
          className: "lao",
        });
        dispatch(clearFormStaff());
      }
    },
    onError() {
      toast.error(`ປັບປຸງຂໍ້ມູນບໍ່ສຳເລັດ ກາລຸນາລອງໃໝ່`, {
        position: "top-center",
        className: "lao",
      });
    },
  });

  const [createStaff, { loading: loadingCreate }] = useMutation(CREATE_STAFF, {
    variables: {
      input: {
        fullname: createForm.fullname,
      },
    },
    refetchQueries: [{ query: GET_STAFF_LIST }],
    onCompleted: (data) => {
      if (data) {
        handleClose();
        toast.success(`ເພີ່ມຂໍ້ມູນສຳເລັດແລ້ວ`, {
          position: "top-center",
          className: "lao",
        });
        dispatch(clearFormStaff());
      }
    },
    onError() {
      toast.error(`ປັບປຸງຂໍ້ມູນບໍ່ສຳເລັດ ກາລຸນາລອງໃໝ່`, {
        position: "top-center",
        className: "lao",
      });
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isEdit) {
      updateStaff();
    } else {
      createStaff();
    }
  };

  const handleChange = (e) => {
    dispatch(
      onChangeStaff({
        ...updateForm,
        [e.target.name]: e.target.value,
      }),
    );
  };

  return (
    <Form className="notolao" onSubmit={handleSubmit}>
      <CustomFormGroup
        label="ຊື່ພະນັກງານ"
        name="fullname"
        onChange={handleChange}
        type="text"
        value={isEdit ? updateForm?.fullname : createForm?.fullname}
        placeholder="ຊື່ພະນັກງານ"
        errorParam="fullname"
        required={true}
      />

      <div className="text-center">
        <SubmitButton loading={loading || loadingCreate} />
      </div>
    </Form>
  );
};

StaffForm.propTypes = {
  handleClose: PropTypes.func.isRequired,
};

export default StaffForm;
